import script from "./PrestadoresPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrestadoresPage.vue?vue&type=script&setup=true&lang=js"

import "./PrestadoresPage.vue?vue&type=style&index=0&id=554a9ef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554a9ef2"]])

export default __exports__